<template>
    <div id="editOm" class="app-inner">
           <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"   @click="$util.reback('/AppConditions')" style="margin-left:0">
                返回
            </div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
             @click="onSubmit('ruleForm')" 
            >
                 {{edittext}}
            </el-button>
            </div>
             <div class="edit-from">
                  <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
             <el-form-item label="工况名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入工况名称【1-30】" clearable></el-input>
                </el-form-item>
                    <el-form-item label="关联仿真应用：" prop="appId">
                 <el-select
            v-model="form.appId"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.appName"
              :value="item.id"
            >
            </el-option>
          </el-select>
                 </el-form-item>
                <el-form-item label="工况文件：" prop="file">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    drag
                    :file-list="fileList"
                    :on-change="handleChangePic"
                    :on-success="handleSuccess"
                    >
                     <i class="el-icon-upload" ></i>
                     <div class="el-upload__text" >将文件拖到此处，或<em>点击上传</em></div>
                     <div slot="tip" class="el-upload__tip" v-if="form.file">工况文件下载地址：<span style="color:#f56c6c">{{form.file}}</span></div>
                    </el-upload>
               </el-form-item>
         </el-form>
             </div>
    </div>
</template>
<script>
import {getApplicationList,editOm,omDetail} from "@/api/index/index" //应用列表、分页查询工况列表、新增 修改工况、工况详情
export default {
    name:'editOm',
    data() {
        return {
            fileList:[],
            headers:{},
            classCurrentPage: 1, //初始页
            classPageSize: 10000, //每页的数据
            options:[],
            value:'',
            edittext:'保存',
            loading:false,
            rules:{
                  name: [
                     {
                        trigger: "blur",
                        message:'请输入工况名称',
                        required: true, 
                     },
                      { min: 1, max: 30, message: '请输入符合规则的工况名称', trigger: 'blur' }
                 ],
                appId: [{ required: true, message: '请选择关联仿真应用', trigger: 'change' }],
                 file:[{ required: true, message: '请上传工况文件', trigger: 'blur' }],
            },
            form:{
                name:'',
                appId:'',
                file:''
            }
        }
    },
    created() {
         this.getAllApplist()
         let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
        if(this.$route.query.id){
            this.edittext = "修改"
            this.getDetail()
        }else{
            this.edittext = "保存"
        }
    },
    methods: {
        // 查看详情
        getDetail(){
            omDetail({id:this.$route.query.id})
            .then(res =>{
                this.form = {
                    name:res.data.name,
                    appId:res.data.appId,
                    file:res.data.file
                }
            })
        },
          // 保存
        onSubmit(formName){
             let params = { ...this.form};
             let method = "post"
             if(this.$route.query.id) params = { ...this.form,id:this.$route.query.id}, method = 'put'
              this.$refs[formName].validate((valid) => { 
                   if(valid){
                     this.commentBness(params,method)
                   }
               })
        },
        // 新增修改公共方法
                          commentBness(params,method){
               this.loading = true
                editOm(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功'); 
                           if(this.$route.query.id) this.$message.success('修改成功'); 
                          
                                setTimeout(() => {
                           this.$router.push("/AppConditions")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
               handleChangePic(file,fileList){
       if (fileList.length > 0) {
                     this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
                 }
 },
        // 上传成功钩子
          handleSuccess(res, file){
           if(res.code == 0){
             this.form.file = res.data.url
           }else{
             this.$util.Notifi('上传失败','error','fa-exclamation-circle')
           }
          },
            // 获取所有仿真应用
        getAllApplist(){
             let params = {
                appName:'',
                id:'',
                classifyId:'2',
                state:'',
                type:'',
                payType:'',
                current: this.classCurrentPage,
                size:this.classPageSize,
                officialType:''
            }
            getApplicationList(params)
            .then(res =>{
               this.options = res.data.records
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .edit-from{
        margin-bottom: 44px;
            .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 50%;
        }
        }
         }
        .App-tab{
            margin: 20px 0;
            
        }
    }
</style>